import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import OpenInBrowser from './OpenInBrowser';
import Loadable from 'react-loadable';

import './App.scss';
import Loading from './Loading';

import SideBar from './sidebar/index';

const Home = Loadable({
  loader: () => import('./pages/home/index'),
  loading: Loading,
  delay: 400
})

const About = Loadable({
  loader: () => import('./pages/about/index'),
  loading: Loading,
  delay: 400
})

const Skills = Loadable({
  loader: () => import('./pages/skills/index'),
  loading: Loading,
  delay: 400
})

const Projects = Loadable({
  loader: () => import('./pages/work/index'),
  loading: Loading,
  delay: 400
})


const Contact = Loadable({
  loader: () => import('./pages/contact/index'),
  loading: Loading,
  delay: 400
})


var isMobile = {
  Android: function() {
      return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function() {
      return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function() {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function() {
      return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function() {
      return navigator.userAgent.match(/IEMobile/i);
  },
  any: function() {
      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
  }
};


const App = () => {
  
  if (isMobile.any()) {
    return (
      <OpenInBrowser />
    )
  }
  return (
  <Router>
    <div className="main-ctn">
        <Route exact path="/" component={Home}/>
        <Route exact path="/about" component={About}/>
        <Route exact path="/skills" component={Skills}/>
        <Route exact path="/projects" component={Projects}/>
        <Route path="/contact" component={Contact}/>
        <SideBar/>
    </div>    
  </Router>
  )
}

export default App;


// WEBPACK FOOTER //
// ./src/components/App.js